import { render, staticRenderFns } from "./UserFloat.vue?vue&type=template&id=323e17c0&scoped=true"
import script from "./UserFloat.vue?vue&type=script&lang=js"
export * from "./UserFloat.vue?vue&type=script&lang=js"
import style0 from "./UserFloat.vue?vue&type=style&index=0&id=323e17c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323e17c0",
  null
  
)

export default component.exports